import React, { useState, type ReactNode } from 'react'
import { Icon } from 'meinian-package/src/component'
import { Dropdown } from 'meinian-package/src/baseComponent'
import classNames from 'classnames'
import './index.less'

export type Value = string | number
export type Option = {
  label:ReactNode
  value:Value
}
export type Group = {
  options:Option[],
  label:ReactNode
  key:string|number
}
export type GroupSelectProps = {
  placeholder?:ReactNode
  groups:Group[]
  values:Value[]
  displayTextClassName?:any,
  displayRender?: (values: Value[], groups: Group[]) => ReactNode
  onChange: (values: Value[], item: any) => void
}

export default function GroupSelect({ onChange, values, groups, placeholder, displayRender, displayTextClassName }:GroupSelectProps) {
  const [visible, setVisible] = useState(false)
  return <Dropdown
    trigger="click"
    overlayClassName=""
    overlay={<div className="mn-group-select">
      {groups.map((m, i) => <span key={m.key}>
        <div className="group-title">{m.label}</div>
        <div className="group-line" />
        <div className="group-list">
          {m.options.map(o => <div
            key={o.value}
            className={classNames('group-list-item')}
            onClick={() => {
              const newValues = [...values]
              newValues[i] = o.value
              setVisible(false)
              onChange(newValues, o)
            }}
          >
            <Icon
              type="m-xiaoyan"
              style={{
                fontSize: 16, marginRight: 8, opacity: values[i] == o.value ? 1 : 0 }}
            />
            {o.label}
          </div>)}
        </div>
      </span>)}
    </div>}
    visible={visible}
    onVisibleChange={vis => setVisible(vis)}
  >
    <div className={classNames('mn-group-select-label', displayTextClassName, { active: visible })}>
      {displayRender(values, groups) || placeholder}
      <Icon type="m-Vxing_xia" style={{ transform: visible ? 'rotate(180deg)' : undefined, transition: 'all 0.3s' }} />
    </div>
  </Dropdown>
}

GroupSelect.defaultProps = {
  placeholder: '请选择',
  displayRender: (values, groups) => {
    const group = groups.find(m => m.options.find(o => o.value == values[0]))
    const option = group?.options.find(o => o.value == values[0])
    return option?.label
  }
}
